import {
  Home,
  Settings,
  Box,
  Users,
  Edit2,
  Upload,
  UserPlus,
  DollarSign,
  Gift,
  Truck,
  Image,
  ShoppingBag,
  CornerDownLeft,
} from "react-feather";

export const MENUITEMS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
    access: "Dashboard",
  },

  {
    title: "Warehouse",
    icon: Box,
    type: "sub",
    active: false,
    access: "Warehouse" || "Category",
    children: [
      {
        title: "Category",
        icon: Box,
        path: "/category-list",
        type: "link",
        access: "Category",
      },

      {
        title: "Products",
        icon: Box,
        path: "/products/list_product",
        type: "link",
        access: "Product",
      },
      {
        title: "Add Product",
        icon: Box,
        path: "/products/create-product",
        type: "link",
        access: "AddProduct",
      },
      {
        title: "Raritylevel",
        icon: Box,
        path: "/products/rarity-list",
        type: "link",
        access: "RarityLevel",
      },
      {
        title: "Brand",
        icon: Box,
        path: "/brand-list",
        type: "link",
        access: "Brand",
      },
    ],
  },

  {
    title: "Box Management",
    icon: Gift,
    path: "/box-list",
    type: "link",
    access: "Box",
  },

  {
    title: "Users",
    icon: Users,
    path: "/users/list-user",
    type: "link",
    access: "Users",
  },

  {
    title: "Order Management",
    icon: Truck,
    path: "/order-management",
    type: "link",
    access: "Orders",
  },
  {
    title: "Banner Management",
    icon: Image,
    path: "/banner-management",
    type: "link",
    access: "Orders",
  },

  {
    title: "Payment History",
    icon: ShoppingBag,
    path: "/payment-history",
    type: "link",
    access: "Deposite",
  },
  {
    title: "Trade History",
    icon: DollarSign,
    path: "/trade-history",
    type: "link",
    access: "trade",
  },
  {
    title: "Feedback",
    icon: Edit2,
    path: "/feedback",
    type: "link",
    access: "feedback",
  },
  {
    title: "Social Proof",
    icon: Upload,
    path: "/winners-social-proof",
    type: "link",
    access: "winnerSocialProof",
  },

  {
    title: "Return order",
    icon: CornerDownLeft,
    path: "/return-order",
    type: "link",
    access: "returnOrder",
  },

  {
    title: "Affiliate Management",
    icon: UserPlus,
    type: "sub",
    active: false,
    access: "Affiliate",
    children: [
      {
        title: "Affiliate Level",
        icon: Users,
        path: "/affiliate-level",
        type: "link",
        access: "AffiliateLevel",
      },
      {
        title: "Affiliate Users",
        icon: Users,
        path: "/affiliate-users",
        type: "link",
        access: "AffiliateUsers",
      },
      {
        title: "Affiliate Stats",
        icon: Users,
        path: "/affiliate-stats",
        type: "link",
        access: "AffiliateStats",
      },
    ],
  },

  {
    title: "Settings",
    icon: Settings,
    type: "sub",
    access: "Setting",
    children: [
      {
        path: "/settings?tab=profile",
        title: "Profile",
        type: "link",
        access: "Profile",
      },
      {
        path: "/settings?tab=changePassword",
        title: "Change Password",
        type: "link",
        access: "ChangePassword",
      },
      {
        path: "/settings?tab=security",
        title: "Security",
        type: "link",
        access: "Security",
      },
      {
        path: "/settings?tab=preferences",
        title: "Preferences",
        type: "link",
        access: "Preferences",
      },
      {
        path: "/settings?tab=liveDropsBets",
        title: "Live Drops",
        type: "link",
        access: "Setting",
      },
    ],
  },
];
